// PasswordResetPopup.js
import React, { useState } from "react";

function PasswordResetPopup({ show, onClose, onResetPassword }) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = () => {
    if (password !== confirmPassword) {
      setError("New passwords do not match.");
      return;
    }
    onResetPassword(password); // Pass the password back to the parent
    setPassword(""); // Clear password field
    setConfirmPassword("");
    setError("");
    onClose(); // Close the popup
  };

  const handleCancel = () => {
    setPassword(""); // Clear password field
    setConfirmPassword("");
    setError("");
    onClose(); // Close the popup
  };

  if (!show) return null; // Render nothing if `show` is false

  return (
    <>
      {/* Overlay for background blur */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent dark overlay
          backdropFilter: "blur(5px)", // Apply blur effect
          zIndex: 1, // Ensure overlay is behind the popup
        }}
        onClick={onClose}
      />

      {/* Popup Window */}
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          padding: "20px",
          backgroundColor: "white",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
          zIndex: 2, // Ensure popup is above the overlay
        }}
      >
        <h5>Reset your password</h5>
        <div>
          Your new password must comply to i-DOCS password complexity rules.
        </div>
        {error && <p style={{ color: "red" }}>{error}</p>}
        <input
          type="password"
          value={password}
          onChange={handlePasswordChange}
          placeholder="New Password"
        />
        <br></br>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Confirm New Password"
        />
        <div>
          <button onClick={handleSubmit}>OK</button>
          <button onClick={handleCancel}>Cancel</button>
        </div>
      </div>
    </>
  );
}

export default PasswordResetPopup;
